import { plainToClass } from 'class-transformer';
import {
  API_ANNOUNCEMENTS_FIND_ALL,
  API_ANNOUNCEMENTS_FIND_ONE,
  API_ANNOUNCEMENTS_CREATE,
  API_ANNOUNCEMENTS_UPDATE,
  API_ANNOUNCEMENTS_DELETE
} from '../api.routes';
import { BaseApi } from './base.api';
import { FindAllResponse } from '../types';
import { AnnouncementDto } from '../dto/announcement.dto';

export class AnnouncementApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<AnnouncementDto>> {
    return this.httpClient
      .get(API_ANNOUNCEMENTS_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(AnnouncementDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<AnnouncementDto> {
    return this.httpClient
      .get(API_ANNOUNCEMENTS_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(AnnouncementDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<AnnouncementDto> {
    return this.httpClient
      .post(API_ANNOUNCEMENTS_CREATE, data)
      .then(({ data }) => {
        return plainToClass(AnnouncementDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<AnnouncementDto> {
    return this.httpClient
      .put(API_ANNOUNCEMENTS_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(AnnouncementDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_ANNOUNCEMENTS_DELETE, {
      pathParams: { uuid }
    });
  }
}
